export default ({
  title,
  description,
  modalState,
  showModal,
  specialButtonText,
  otherButtonCancelDelete = false,
  otherButtonCancel = false,
  onClickDelete,
  showProgress,
  valueProgress,
  iWantGoToHome,
  state = "loading",
}) => {
  return {
    showModal: showModal || true,
    modalState: modalState || {
      buttonText: specialButtonText || "Entendido",
      disabledContinue: false,
      showModal: true,
      responseState: state,
      responseToContinueTitle: title,
      responseToContinue: description,
      otherButtonCancel,
      otherButtonCancelDelete,
      onClickDelete,
      showProgress,
      valueProgress,
      iWantGoToHome,
    },
  };
};